import { axios, Response } from '..'

export type PersonalData = {
  userId: number
  personaId: string
  firstName: string
  lastName: string
  cpf: string
  gender: string
  birthDay: string
  email: string
}

export default async function getUserByCpf(
  cpf: string
): Response<PersonalData> {
  return await axios.get(`/v1/users/${cpf}`)
}
